import { Dispatcher } from '@npm-registry/helpers/dispatcher';
import { RecommendationProductWithAnalytics } from '../../store/recommendationProducts/types';

type RecommendationProductDispatcherData = [
  data: RecommendationProductWithAnalytics
];

// Успешное добавление товара
export const OnAfterRecommendationProductAdd =
  new Dispatcher<RecommendationProductDispatcherData>();
